// Anmeldeprobe (Schlusslauf 3, 10.10.2026): nach dem Löschen des eigenen Kontos zeigt die Anmeldeseite einmal die Antwort
// des Servers (was gelöscht ist und was bleibt; backend operator/deletionJob.ts deletionAnswer, LEB-04). Der Löschdialog
// merkt sie für genau den einen Seitenwechsel im Sitzungsspeicher des Tabs. Der Satz enthält keine Kennung und kein
// Geheimnis; angezeigt wird er als Text. Ohne Speicher gilt der kurze Satz. Geprüft in frontend/tests/konto-geloescht.test.mjs.
const SCHLUESSEL = 'clairis.konto-geloescht';
export const KONTO_GELOESCHT = 'Ihr Konto wurde gelöscht.';

type Speicher = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;
const tabSpeicher = (): Speicher | null => { try { return window.sessionStorage; } catch { return null; } };

export function merkeLoeschAntwort(satz: unknown, speicher: Speicher | null = tabSpeicher()): void {
  if (typeof satz !== 'string' || !satz.trim()) return;
  try { speicher?.setItem(SCHLUESSEL, satz.trim().slice(0, 2000)); } catch { /* dann gilt der kurze Satz */ }
}

export function leseLoeschAntwort(speicher: Speicher | null = tabSpeicher()): string {
  try { return speicher?.getItem(SCHLUESSEL) || KONTO_GELOESCHT; } catch { return KONTO_GELOESCHT; }
}

export function vergissLoeschAntwort(speicher: Speicher | null = tabSpeicher()): void {
  try { speicher?.removeItem(SCHLUESSEL); } catch { /* nichts zu vergessen */ }
}
